import { Component } from 'react'

import { TaxonomyTerm } from './TaxonomyTerm'

export class Taxonomy extends Component {

	constructor( props ) {
		super( props )

		this.state = {
			toggleClass: this.props.showList ? 'show-list': 'hide-list',
		}

		this.setToggleClass( this.props.taxonomy.terms, this.props.activeTerms );
		this.toggleListDisplay = this.toggleListDisplay.bind( this )
	}

	setToggleClass( terms, activeTerms ) {
		let toggleClass = this.state.toggleClass
		let termsArray = Object.values( this.props.taxonomy.terms );

		termsArray.forEach( term => {
			if ( activeTerms.includes( term.term_id ) ) {
				toggleClass = 'show-list'
			}
		})

		this.state.toggleClass = toggleClass
	}

	toggleListDisplay() {
		let toggleClass = 'show-list' === this.state.toggleClass ? 'hide-list' : 'show-list'

		this.setState({ 
			toggleClass: toggleClass,
		})
	}

	/**
	 * Recursively renders the term list from nested taxonomies
	 * 
	 * @param  {object} term WP_Term object
	 * @return {JSX}         Term list JSX
	 */
	renderTermList( term ) {
		let children
		let showList = false;
		if ( term.children ) {
			let childrenArray = Object.values( term.children )

			children = (
				<ul className="pf-taxonomy__sub-list">
					{ childrenArray.map( childTerm => this.renderTermList( childTerm ) ) }
				</ul>
			)

			// Check if child is selected, if so, show the sub menu open.
			for ( let key in childrenArray ) {
				let child = childrenArray[ key ]
				if ( this.props.activeTerms.includes( child.term_id ) ) {
					showList = true;
				}
			}
		}

		let isActive = this.props.activeTerms.includes( term.term_id );

		return (
			<TaxonomyTerm 
				term={ term } 
				taxonomyName={ this.props.taxonomy.name }
				children={ children } 
				addTermToQuery={ this.props.addTermToQuery } 
				removeTermFromQuery={ this.props.removeTermFromQuery }
				key={ term.term_id }
				isActive={ isActive }
				showList={ showList }
			/>
		)
	}

	render() {

		let termsArray = Object.values( this.props.taxonomy.terms );
		if ( termsArray.length && 'undefined' !== typeof termsArray[0].term_order ) {
			termsArray.sort( (a, b) => a.term_order > b.term_order ? 1 : -1 );
		}

		return (
			<div className={ `pf-taxonomy ${this.state.toggleClass}` }>
				<div className="pf-taxonomy__top" onClick={ this.toggleListDisplay }>
					<div className="pf-taxonomy__label">{ this.props.taxonomy.label }</div>

					<button type="button" className="pf-taxonomy__toggle" />
				</div>

				<ul className="pf-taxonomy__list">
					{termsArray.map( term => {
						return this.renderTermList( term )
					})}
				</ul>
			</div>
		)
	}

}